import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=3b2f8b57&"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports